export default theme => ({
  container: {
    padding: 10
  },
});
